import { AffiliateEmptyStateEnum } from 'modules/affiliate/enums/affiliate-empty-state-enum'
import { DataWithPaginationInterface } from 'shared/types/pagination-interface'

interface GetAffiliateEmptyStateParams<T> {
  data: DataWithPaginationInterface<T> | undefined
  hasActivity: boolean | undefined
  isActivityLoading: boolean
  isFiltered: boolean
}

const getEmptyStateType = (hasActivity: boolean | undefined, isFiltered: boolean) => {
  if (hasActivity === false) return AffiliateEmptyStateEnum.NoActivity
  if (isFiltered) return AffiliateEmptyStateEnum.NoMatch
  return AffiliateEmptyStateEnum.NoPeriodData
}

export const getAffiliateEmptyState = <T>({
  data,
  hasActivity,
  isActivityLoading,
  isFiltered,
}: GetAffiliateEmptyStateParams<T>) => ({
  emptyState: getEmptyStateType(hasActivity, isFiltered),
  // An empty page stays loading until the statistic arrives, otherwise a new affiliate sees the
  // "for this period" copy flash before the "yet" one.
  tableData: isActivityLoading && data?.items.length === 0 ? undefined : data,
})
